import React from 'react'
import { Box } from 'theme-ui'
import Spinner from '~/components/Generic/Spinner'

const wrapperStyle = {
  position: 'fixed',
  margin: 'auto',
  top: 0,
  background: '#00E0BE',
  width: '100%',
  height: '100%',
  overflow: 'hidden',
  zIndex: 10
}

const spinnerStyle = {
  width: 'fit-content',
  margin: '25% auto'
}

const CustomLoading = () => {
  return (
    <>
      <Box sx={wrapperStyle} data-testid="big-spinner">
        <Box sx={spinnerStyle}>
          <Spinner size={100} />
        </Box>
      </Box>
    </>
  )
}

export default CustomLoading
